import {useGetAndSet} from "./useGetAndSet";
import {createSetVehicleMakeDataAction} from "../actions/dataActions";

export const useVehicleMakeData = (params, dataFresh, nofetch) => {
    return useGetAndSet("vehiclemake", params, createSetVehicleMakeDataAction, dataFresh, nofetch)
}